import { useStaticQuery, graphql } from 'gatsby';
import defaultOgpImage from '@/images/og.png';
import AppIcon from '@/images/icon_app.png';
import favicon from '@/images/favicon.ico';

type Props = {
  uniqueOgImage?: string;
  uniqueTitle?: string;
  uniqueDescription?: string;
  url: string;
};

/**
 * ミエルカ用のタグ埋め込み（インライスクリプト部分）
 */
const mierucaScript = `
  window.__fid = window.__fid || [];__fid.push([298475738]);
  (function() {
  function mieruca(){if(typeof window.__fjsld != "undefined") return; window.__fjsld = 1; var fjs = document.createElement('script'); fjs.type = 'text/javascript'; fjs.async = true; fjs.id = "fjssync"; var timestamp = new Date;fjs.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://hm.mieru-ca.com/service/js/mieruca-hm.js?v='+ timestamp.getTime(); var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(fjs, x); };
  setTimeout(mieruca, 500); document.readyState != "complete" ? (window.attachEvent ? window.attachEvent("onload", mieruca) : window.addEventListener("load", mieruca, false)) : mieruca();
  })();
`;

const Seo: React.FC<Props> = ({
  uniqueOgImage,
  uniqueTitle,
  uniqueDescription,
  url,
}) => {
  const { site } = useStaticQuery<GatsbyTypes.SeoQuery>(query);
  const image = !uniqueOgImage ? defaultOgpImage : uniqueOgImage;
  const siteUrl =
    typeof site?.siteMetadata?.siteUrl === 'string'
      ? site?.siteMetadata?.siteUrl
      : '';

  const titleSuffix = ' | POSTD';
  const title = !uniqueTitle
    ? site?.siteMetadata?.title
    : `${uniqueTitle}${titleSuffix}`;

  const description = !uniqueDescription
    ? site?.siteMetadata?.description
    : uniqueDescription;

  const ogUrl = /https?:\/\/.+/.test(url) ? url : `${siteUrl}${url}`;
  const ogImage = /https?:\/\/.+/.test(image) ? image : `${siteUrl}${image}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:site_name" content={site?.siteMetadata?.title} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:image" content={ogImage} />
      <link rel="icon" type="image/ico" href={favicon} />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content={AppIcon} />
      <meta name="apple-mobile-web-app-title" content="POSTD" />
      <link rel="apple-touch-icon-precomposed" href={AppIcon} />
      {/* ミエルカ用タグ埋め込み */}
      <script
        type="text/javascript"
        id="mierucajs"
        /* biome-ignore lint/security/noDangerouslySetInnerHtml: インラインスクリプトを埋め込む */
        dangerouslySetInnerHTML={{ __html: mierucaScript }}
      />
    </>
  );
};

const query = graphql`
  query Seo {
    site {
      siteMetadata {
        description
        title
        siteUrl
      }
    }
  }
`;

export default Seo;
